webpackJsonp([8],{

/***/ 815:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(949),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-03c90b56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isloading: false,
      wrapperClick: true
    };
  },

  methods: {
    navigateToCentralAnalytics: function navigateToCentralAnalytics() {
      var _this = this;

      this.isLoading = true;
      setTimeout(function () {
        _this.$router.push("central_analytics");
      }, 1000);
    },
    wrapperClicked: function wrapperClicked() {
      this.wrapperClick = !this.wrapperClick;
    }
  }
});

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(802)(true);
// imports


// module
exports.push([module.i, "body[data-v-03c90b56]{font-family:Open Sans}.list_short[data-v-03c90b56]{height:500px!important}.update_title[data-v-03c90b56]{text-align:center;font-size:31px;font-weight:900;letter-spacing:0;color:#232323;opacity:1;margin-top:20px}.update_subtitle[data-v-03c90b56]{font-weight:600!important;font-size:15px;text-align:center;letter-spacing:0;color:#232323;opacity:1}.item[data-v-03c90b56]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:auto;flex:auto;overflow-y:hidden}.timeline[data-v-03c90b56]{position:relative;display:table;margin-left:0;margin-right:auto;margin-top:3.5rem}.timeline[data-v-03c90b56]:before{content:\"\";position:absolute;top:5px;bottom:0;left:27%;width:2px;background:#ddd}.timeline[data-v-03c90b56]:after{content:\"\";display:table;clear:both}.entry[data-v-03c90b56]{clear:both;text-align:left;position:relative}.entry .left[data-v-03c90b56]{margin-bottom:.5em;float:left;width:25%;padding-right:5px;position:relative}.entry .left[data-v-03c90b56]:before{content:\"\";position:absolute;border:8px solid #007d53;border-radius:100%;top:15%;right:-11%;z-index:99}.date[data-v-03c90b56]{text-align:right;letter-spacing:0;color:#171717;opacity:1;font-weight:600;font-size:14px}.right[data-v-03c90b56]{margin:0 0 3em;float:right;width:71%;line-height:.4}.right ul[data-v-03c90b56]{padding-left:0;list-style-type:none}.right ul li[data-v-03c90b56]:before{content:\"\\2013\";margin-right:.3em}.list[data-v-03c90b56]{margin-left:-1px;padding-top:0}.list li[data-v-03c90b56]{text-align:left;font-size:16px;letter-spacing:0;color:#171717;font-weight:500;opacity:1}.right__title[data-v-03c90b56]{text-align:left;font-size:20px;letter-spacing:0;color:#007d53;font-weight:700;opacity:1}.right__subtitle[data-v-03c90b56]{text-align:left;font-size:16.5px;letter-spacing:0;font-weight:600;color:#515151;opacity:1}.btn-more[data-v-03c90b56]{background-color:#007d53!important;color:#fff!important;border-color:#007d53!important;position:absolute;-webkit-box-shadow:0 2px 10px rgba(0,0,0,.4);box-shadow:0 2px 10px rgba(0,0,0,.4);width:127.5px;height:41px;left:-15.5%}@media screen and (max-width:769px){.list-short[data-v-03c90b56]{max-height:450px!important}#timeline[data-v-03c90b56]{margin:auto}.left p[data-v-03c90b56]{font-size:10px;padding-right:0;line-height:16px}.right[data-v-03c90b56]{line-height:18px}}@media screen and (max-width:426px){.left[data-v-03c90b56]:before{right:-19%!important}.date[data-v-03c90b56]{text-align:left}.right[data-v-03c90b56]{width:67%}.btn-more[data-v-03c90b56]{left:3%}}@media screen and (min-width:424px) and (max-width:770px){.left[data-v-03c90b56]:before{right:-16.5%!important}}@media screen and (min-width:768px) and (max-width:1023px){.left[data-v-03c90b56]:before{right:-12.5%!important}.btn-more[data-v-03c90b56]{left:1%}}@media screen and (min-width:1024px) and (max-width:1053px){.btn-more[data-v-03c90b56]{left:1%}}@media screen and (min-width:1054px) and (max-width:1698px){.btn-more[data-v-03c90b56]{left:4%}}.back-to-car-icon[data-v-03c90b56]{color:#fff!important;top:105px;cursor:pointer}@media only screen and (max-width:600px){div.back-to-car-icon[data-v-03c90b56]{top:140px}}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/updateLog.vue"],"names":[],"mappings":"AAEA,sBACE,qBAAuB,CACxB,AACD,6BACE,sBAAyB,CAC1B,AACD,+BACE,kBAAmB,AACnB,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,cAAe,AACf,UAAW,AACX,eAAiB,CAClB,AACD,kCACE,0BAA4B,AAC5B,eAAgB,AAChB,kBAAmB,AACnB,iBAAkB,AAClB,cAAe,AACf,SAAW,CACZ,AACD,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,cAAe,AACX,UAAW,AACnB,iBAAmB,CACpB,AACD,2BACE,kBAAmB,AACnB,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,iBAAmB,CACpB,AACD,kCACI,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,SAAU,AACV,UAAW,AACX,eAAiB,CACpB,AACD,iCACI,WAAY,AACZ,cAAe,AACf,UAAY,CACf,AACD,wBACE,WAAY,AACZ,gBAAiB,AACjB,iBAAmB,CACpB,AACD,8BACI,mBAAoB,AACpB,WAAY,AACZ,UAAW,AACX,kBAAmB,AACnB,iBAAmB,CACtB,AACD,qCACM,WAAY,AACZ,kBAAmB,AACnB,yBAA0B,AAC1B,mBAAoB,AACpB,QAAS,AACT,WAAY,AACZ,UAAY,CACjB,AACD,uBACE,iBAAkB,AAClB,iBAAkB,AAClB,cAAe,AACf,UAAW,AACX,gBAAiB,AACjB,cAAgB,CACjB,AACD,wBACE,eAAgB,AAChB,YAAa,AACb,UAAW,AACX,cAAgB,CACjB,AACD,2BACI,eAAgB,AAChB,oBAAsB,CACzB,AACD,qCACM,gBAAa,AACb,iBAAmB,CACxB,AACD,uBACE,iBAAkB,AAClB,aAAe,CAChB,AACD,0BACE,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,gBAAiB,AACjB,SAAW,CACZ,AACD,+BACE,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,gBAAiB,AACjB,SAAW,CACZ,AACD,kCACE,gBAAiB,AACjB,iBAAkB,AAClB,iBAAkB,AAClB,gBAAiB,AACjB,cAAe,AACf,SAAW,CACZ,AACD,2BACE,mCAAqC,AACrC,qBAAwB,AACxB,+BAAiC,AACjC,kBAAmB,AACnB,6CAAoD,AAC5C,qCAA4C,AACpD,cAAe,AACf,YAAa,AACb,WAAa,CACd,AACD,oCACA,6BACI,0BAA6B,CAChC,AACD,2BACI,WAAa,CAChB,AACD,yBACI,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACrB,AACD,wBACI,gBAAkB,CACrB,CACA,AACD,oCACA,8BACI,oBAAuB,CAC1B,AACD,uBACI,eAAiB,CACpB,AACD,wBACI,SAAW,CACd,AACD,2BACI,OAAS,CACZ,CACA,AACD,0DACA,8BACI,sBAAyB,CAC5B,CACA,AACD,2DACA,8BACI,sBAAyB,CAC5B,AACD,2BACI,OAAS,CACZ,CACA,AACD,4DACA,2BACI,OAAS,CACZ,CACA,AACD,4DACA,2BACI,OAAS,CACZ,CACA,AACD,mCACE,qBAAwB,AACxB,UAAW,AACX,cAAgB,CACjB,AACD,yCACA,sCACI,SAAW,CACd,CACA","file":"updateLog.vue","sourcesContent":["\n@charset \"UTF-8\";\nbody[data-v-03c90b56] {\n  font-family: Open Sans;\n}\n.list_short[data-v-03c90b56] {\n  height: 500px !important;\n}\n.update_title[data-v-03c90b56] {\n  text-align: center;\n  font-size: 31px;\n  font-weight: 900;\n  letter-spacing: 0;\n  color: #232323;\n  opacity: 1;\n  margin-top: 20px;\n}\n.update_subtitle[data-v-03c90b56] {\n  font-weight: 600 !important;\n  font-size: 15px;\n  text-align: center;\n  letter-spacing: 0;\n  color: #232323;\n  opacity: 1;\n}\n.item[data-v-03c90b56] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: auto;\n          flex: auto;\n  overflow-y: hidden;\n}\n.timeline[data-v-03c90b56] {\n  position: relative;\n  display: table;\n  margin-left: 0;\n  margin-right: auto;\n  margin-top: 3.5rem;\n}\n.timeline[data-v-03c90b56]:before {\n    content: '';\n    position: absolute;\n    top: 5px;\n    bottom: 0;\n    left: 27%;\n    width: 2px;\n    background: #ddd;\n}\n.timeline[data-v-03c90b56]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.entry[data-v-03c90b56] {\n  clear: both;\n  text-align: left;\n  position: relative;\n}\n.entry .left[data-v-03c90b56] {\n    margin-bottom: .5em;\n    float: left;\n    width: 25%;\n    padding-right: 5px;\n    position: relative;\n}\n.entry .left[data-v-03c90b56]:before {\n      content: '';\n      position: absolute;\n      border: 8px solid #007D53;\n      border-radius: 100%;\n      top: 15%;\n      right: -11%;\n      z-index: 99;\n}\n.date[data-v-03c90b56] {\n  text-align: right;\n  letter-spacing: 0;\n  color: #171717;\n  opacity: 1;\n  font-weight: 600;\n  font-size: 14px;\n}\n.right[data-v-03c90b56] {\n  margin: 0 0 3em;\n  float: right;\n  width: 71%;\n  line-height: .4;\n}\n.right ul[data-v-03c90b56] {\n    padding-left: 0;\n    list-style-type: none;\n}\n.right ul li[data-v-03c90b56]:before {\n      content: \"–\";\n      margin-right: .3em;\n}\n.list[data-v-03c90b56] {\n  margin-left: -1px;\n  padding-top: 0;\n}\n.list li[data-v-03c90b56] {\n  text-align: left;\n  font-size: 16px;\n  letter-spacing: 0;\n  color: #171717;\n  font-weight: 500;\n  opacity: 1;\n}\n.right__title[data-v-03c90b56] {\n  text-align: left;\n  font-size: 20px;\n  letter-spacing: 0;\n  color: #007D53;\n  font-weight: 700;\n  opacity: 1;\n}\n.right__subtitle[data-v-03c90b56] {\n  text-align: left;\n  font-size: 16.5px;\n  letter-spacing: 0;\n  font-weight: 600;\n  color: #515151;\n  opacity: 1;\n}\n.btn-more[data-v-03c90b56] {\n  background-color: #007D53 !important;\n  color: white !important;\n  border-color: #007D53 !important;\n  position: absolute;\n  -webkit-box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);\n          box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);\n  width: 127.5px;\n  height: 41px;\n  left: -15.5%;\n}\n@media screen and (max-width: 769px) {\n.list-short[data-v-03c90b56] {\n    max-height: 450px !important;\n}\n#timeline[data-v-03c90b56] {\n    margin: auto;\n}\n.left p[data-v-03c90b56] {\n    font-size: 10px;\n    padding-right: 0;\n    line-height: 16px;\n}\n.right[data-v-03c90b56] {\n    line-height: 18px;\n}\n}\n@media screen and (max-width: 426px) {\n.left[data-v-03c90b56]:before {\n    right: -19% !important;\n}\n.date[data-v-03c90b56] {\n    text-align: left;\n}\n.right[data-v-03c90b56] {\n    width: 67%;\n}\n.btn-more[data-v-03c90b56] {\n    left: 3%;\n}\n}\n@media screen and (min-width: 424px) and (max-width: 770px) {\n.left[data-v-03c90b56]:before {\n    right: -16.5% !important;\n}\n}\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n.left[data-v-03c90b56]:before {\n    right: -12.5% !important;\n}\n.btn-more[data-v-03c90b56] {\n    left: 1%;\n}\n}\n@media screen and (min-width: 1024px) and (max-width: 1053px) {\n.btn-more[data-v-03c90b56] {\n    left: 1%;\n}\n}\n@media screen and (min-width: 1054px) and (max-width: 1698px) {\n.btn-more[data-v-03c90b56] {\n    left: 4%;\n}\n}\n.back-to-car-icon[data-v-03c90b56] {\n  color: white !important;\n  top: 105px;\n  cursor: pointer;\n}\n@media only screen and (max-width: 600px) {\ndiv.back-to-car-icon[data-v-03c90b56] {\n    top: 140px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(891);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("123b0b96", content, true, {});

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "250px",
      "height": "250px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'list_short': _vm.wrapperClick
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12 col-xs-offset-4",
    staticStyle: {
      "padding-top": "25px",
      "padding-bottom": "80px",
      "color": "white"
    }
  }, [_c('button', {
    staticClass: "btn btn-more",
    on: {
      "click": _vm.wrapperClicked
    }
  }, [_vm._v("\n        " + _vm._s(_vm.wrapperClick ? "Show More" : "Show Less") + "\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h1', {
    staticClass: "update_title",
    attrs: {
      "id": "top_of_page"
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('h5', {
    staticClass: "update_subtitle"
  }, [_vm._v("\n        The MSDAT platform is updated regularly to ensure optimum experience\n        and data quality.\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline",
    attrs: {
      "id": "timeline"
    }
  }, [_c('section', {
    staticClass: "entry"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "date"
  }, [_vm._v("October 30th, 2019")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h3', {
    staticClass: "right__title"
  }, [_vm._v("Version 1.3 Updates (Performance Improvement)")]), _vm._v(" "), _c('h4', {
    staticClass: "right__subtitle"
  }, [_vm._v("Features")]), _vm._v(" "), _c('p', [_vm._v("The following features were introduced in version 1.3 of the MSDAT platform:")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("Indicator Overview with related indicators")]), _vm._v(" "), _c('li', [_vm._v("Indicator Trend analysis across data sources")]), _vm._v(" "), _c('li', [_vm._v("Comparison of selected Indicator and related indicators across data sources (Routine, Surveys, Estimate)")]), _vm._v(" "), _c('li', [_vm._v("Indicator distribution by states and LGAs")]), _vm._v(" "), _c('li', [_vm._v("Indicator definitions and meta-data")]), _vm._v(" "), _c('li', [_vm._v("Geopolitical zonal analysis of Indicator")]), _vm._v(" "), _c('li', [_vm._v("Multi-Source Indicator Comparison")]), _vm._v(" "), _c('li', [_vm._v("Multi-Dataset Comparison of Indicator by states")]), _vm._v(" "), _c('li', [_vm._v("MSDAT Onboarding & Tour guide")]), _vm._v(" "), _c('li', [_vm._v("Data Download in multiple formats")]), _vm._v(" "), _c('li', [_vm._v("Share dashboard feature")]), _vm._v(" "), _c('li', [_vm._v("Mobile responsive view")]), _vm._v(" "), _c('li', [_vm._v("Feedback tool")]), _vm._v(" "), _c('li', [_vm._v("Offline web capabilities")]), _vm._v(" "), _c('li', [_vm._v("Submit data source feature")]), _vm._v(" "), _c('li', [_vm._v("Date Last Updated on dashboard footer ")]), _vm._v(" "), _c('li', [_vm._v("Automatic cache-clearing for browser after 30 days")]), _vm._v(" "), _c('li', [_vm._v("Automatic browser caches clearing if page doesn’t load after 30 seconds")]), _vm._v(" "), _c('li', [_vm._v("MSDAT Contact page ")]), _vm._v(" "), _c('li', [_vm._v("MSDAT About page with information on available data")]), _vm._v(" "), _c('li', [_vm._v("Contact form pop-up ")]), _vm._v(" "), _c('li', [_vm._v("Unsupported browser pop-up alert")]), _vm._v(" "), _c('li', [_vm._v("GZip compression enabled ")])]), _vm._v(" "), _c('h4', {
    staticClass: "right__subtitle"
  }, [_vm._v("Data Updates")]), _vm._v(" "), _c('p', [_vm._v("The following data updates were made in version 1.3 of the MSDAT platform:")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_vm._v("32 Indicators across 17 data sources and 6 program areas: RMNCH, Malaria, Immunization, Nutrition, Mortality & HIV")]), _vm._v(" "), _c('li', [_vm._v("National & SDG Targets added where applicable")]), _vm._v(" "), _c('li', [_vm._v("Confidence range values added where applicable")])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.916ef1219db8b8d84f2c.js